import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface TextareaProps {
    register: UseFormRegisterReturn;
    placeholder?: string;
    disabled?: boolean;
    label?: string;
    name?: string;
    className?: string;
    rows?: number;
    cols?: number;
}

const Textarea: React.FC<TextareaProps> = ({
    register,
    placeholder,
    disabled,
    label,
    name,
    className,
    rows = 4,
    cols = 50,
}) => {
    return (
        <div className="form-group">
            {label && <label className="form-label" htmlFor={name}>{label}</label>}
            <textarea
                {...register}
                placeholder={placeholder}
                rows={rows}
                cols={cols}
                disabled={disabled}
                className={`form-control ${className}`}
            />
        </div>
    );
};

export default Textarea;
